import React from 'react'
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

import { BtnClose, ButtonDiv, CheckBox, Header, OverLay, SelectedList, SiteAddr, SiteInfo, SiteName, Wrapper } from './styles';
import CartItem from './CartItem';
import { Box } from '@mui/material';
import { parseJapanesePrice } from 'Common';

const CartGoods = ({ idCartGoods }) => {
    const cart = useSelector(state => state.cart);


    return (
        <>
            <CheckBox id={idCartGoods} hidden />
            <OverLay htmlFor={idCartGoods} />
            <Wrapper>
                <Header>
                    <SiteInfo>
                        <SiteName>{cart?.siteName || '未入力'}</SiteName>
                        <SiteAddr>{cart?.siteAddr || '―'}</SiteAddr>
                    </SiteInfo>
                    <BtnClose htmlFor={idCartGoods} ><FontAwesomeIcon icon={faXmark} /></BtnClose>
                </Header>
                <SelectedList>
                    {cart.selectedList?.length > 0 ? (cart.selectedList.map((item) => {
                        return (<CartItem key={`${item.goods.GoodsID}_${item.goods.GoodsSubID}_${item.goods.GoodsName}`} item={item} />)
                    })) : <></>}
                    {cart.selectedList?.length > 0 ? (
                        <>
                            <Box sx={{ padding: '0 8px' }}>
                                <h3>金額：￥{cart.selectedList?.reduce((total, item) => total + (parseJapanesePrice(item.goods.Price) * item.quantity), 0).toLocaleString()}（税抜）</h3>
                            </Box>
                            <ButtonDiv>
                                <Link className='ButtonConfirm' to={'/cart'}>注文に進む</Link>
                            </ButtonDiv>
                        </>
                    ) : (<></>)}
                </SelectedList>
            </Wrapper>
        </>
    )
}


CartGoods.propTypes = {
    idCartGoods: PropTypes.string,
}

CartGoods.defaultProps = {
    idCartGoods: 'id_Cart',
}

export default CartGoods;